module.exports = __webpack_public_path__ + "media/images/responsive/articles/icon_arrow_pager-99cd4184621dbca83b81c41e24bca6a5.svg";